import { render, staticRenderFns } from "./CatalogPermissions.vue?vue&type=template&id=1a2ba8b8&scoped=true"
import script from "./CatalogPermissions.vue?vue&type=script&lang=js"
export * from "./CatalogPermissions.vue?vue&type=script&lang=js"
import style0 from "./CatalogPermissions.vue?vue&type=style&index=0&id=1a2ba8b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2ba8b8",
  null
  
)

export default component.exports